import React, { useContext } from 'react';
import { eachDayOfInterval, endOfWeek, startOfMonth, startOfWeek, startOfDay, endOfMonth, format, isSameMonth, isSameDay, eachWeekOfInterval, isSameWeek, isBefore } from 'date-fns';
import { CalendarContext } from '../../context/CalendarContext';
import '../../styles/weekPicker.scss';

const WeekPicker = () => {
  const { currentDate, setCurrentDate, weekDay, setWeekDay } = useContext(CalendarContext);
  const startOfMonthDate = startOfMonth(currentDate);
  const endOfMonthDate = endOfMonth(currentDate);

  const today = new Date();

  // Se calculan todas las semanas del mes actual (semanas de lunes a domingo, igual que la grilla).
  let weeksOfMonth = eachWeekOfInterval({
    start: startOfMonthDate,
    end: endOfMonthDate
  }, { weekStartsOn: 1 });

  // Esta función maneja el clic en un día, estableciendo la semana a la que pertenece el día seleccionado.
  const handleDayClick = (day) => {
    if (!isSameWeek(day, currentDate, { weekStartsOn: 1 })) {
      setCurrentDate(day);
      setWeekDay(day);
    } else {
      if (!isSameMonth(day, currentDate)) {
        setCurrentDate(day);
      }
      setWeekDay(day);
    }
  };

  return (
    <div className='week-picker'>
      <div>
        <div className='week-header'>
          <span>M</span>
          <span>T</span>
          <span>W</span>
          <span>T</span>
          <span>F</span>
          <span>S</span>
          <span>S</span>
        </div>
        {weeksOfMonth.map((weekStart) => {
          // Calcula los días de la semana actual.
          const weekDays = eachDayOfInterval({
            start: startOfWeek(weekStart, { weekStartsOn: 1 }),
            end: endOfWeek(weekStart, { weekStartsOn: 1 })
          });
          return (
            <div key={weekStart.toString()} className={`week ${isSameWeek(weekStart, currentDate, { weekStartsOn: 1 }) ? 'selected' : ''}`}>
              {weekDays.map(day => (
                <button
                  disabled={isBefore(day, startOfDay(today))}
                  key={day.toString()}
                  className={`day ${isSameDay(day, weekDay) ? 'selected' : ''} ${!isSameMonth(day, startOfMonthDate) ? 'different-month' : ''} ${isBefore(day, startOfDay(today)) ? 'past' : ''}`}
                  onClick={() => handleDayClick(day)}
                >
                  {format(day, 'dd')}
                </button>
              ))}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default WeekPicker;
